(function () {
  if (window.__nxCartRecoInit) return;
  window.__nxCartRecoInit = true;

  function showCard(wrap, dir) {
    var cards = Array.prototype.slice.call(wrap.querySelectorAll('[data-nx-reco-card]'));
    if (!cards.length) return;
    var current = cards.findIndex(function (c) {
      return c.classList.contains('is-active');
    });
    if (current === -1) current = 0;
    var next = (current + dir + cards.length) % cards.length;
    cards[current].classList.remove('is-active');
    cards[next].classList.add('is-active');
  }

  document.addEventListener('click', function (e) {
    var prevBtn = e.target.closest('[data-nx-reco-prev]');
    var nextBtn = e.target.closest('[data-nx-reco-next]');
    if (!prevBtn && !nextBtn) return;
    var wrap = (prevBtn || nextBtn).closest('.nx-cart-reco');
    if (!wrap) return;
    showCard(wrap, prevBtn ? -1 : 1);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-nx-reco-form]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('.nx-cart-reco__add');
    var originalText = btn ? btn.textContent : '';
    var formData = new FormData(form);

    var sectionIds = Array.prototype.slice
      .call(document.querySelectorAll('cart-items-component'))
      .map(function (el) {
        return el.dataset.sectionId;
      })
      .filter(Boolean);
    if (sectionIds.length) {
      formData.append('sections', sectionIds.join(','));
    }

    if (btn) {
      btn.disabled = true;
      btn.textContent = '…';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function (response) {
        var id = formData.get('id');
        var event = new Event('cart:update', { bubbles: true });
        event.detail = {
          resource: response,
          sourceId: id ? id.toString() : '',
          data: {
            source: 'nx-cart-reco',
            itemCount: 1,
            sections: response.sections,
          },
        };
        document.dispatchEvent(event);
        if (btn) btn.textContent = originalText;
      })
      .catch(function () {
        if (btn) {
          btn.disabled = false;
          btn.textContent = originalText;
        }
      });
  });
})();
